import { render } from "./CompanyColors.vue?vue&type=template&id=911b3bb4&scoped=true"
import script from "./CompanyColors.vue?vue&type=script&lang=js"
export * from "./CompanyColors.vue?vue&type=script&lang=js"

import "./CompanyColors.vue?vue&type=style&index=0&id=911b3bb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-911b3bb4"]])

export default __exports__